module.exports = __webpack_public_path__ + "img/menu-nota.50a5f1e2.svg";